export default {"src":"/_next/static/media/logout.899ade8c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};